import { NuqsAdapter, enableHistorySync } from 'nuqs/adapters/react'
import type { PropsWithChildren } from 'react'

import { AuthProvider } from './auth-provider'
import { SidebarProvider } from '@/components/ui/sidebar'
import { TooltipProvider } from '@/components/ui/tooltip'
import { ReactQueryProvider } from '@/providers/react-query-provider'

// The plain React adapter only hears its own writes and popstate. Without this,
// a react-router navigate() (e.g. useGlobalScanner on a body-focused skid scan)
// changes the URL but nuqs keeps the old `?skid=`, so the sheet opens only
// after a reload.
enableHistorySync()

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <NuqsAdapter>
      <ReactQueryProvider>
        <AuthProvider>
          <SidebarProvider>
            <TooltipProvider>{children}</TooltipProvider>
          </SidebarProvider>
        </AuthProvider>
      </ReactQueryProvider>
    </NuqsAdapter>
  )
}
